/**
 * @generated SignedSource<<ab0f669a9a9e819a18838e701ff3e044>>
 * @relayHash d819e6425aaf11a85d693b60cfaa0648
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 956ecf57fed159f307bc7ba37a046a1677b7df31f93f33b0f28c558e117ebe53

import type { ConcreteRequest, GraphQLSubscription } from 'relay-runtime';
export type realtimeUpdater_issueCreated_Subscription$variables = {
  cloudId: string;
  projectId: string;
};
export type realtimeUpdater_issueCreated_Subscription$data = {
  readonly jira: {
    readonly onIssueCreatedByProject: {
      readonly id: string;
    } | null | undefined;
  } | null | undefined;
};
export type realtimeUpdater_issueCreated_Subscription = {
  response: realtimeUpdater_issueCreated_Subscription$data;
  variables: realtimeUpdater_issueCreated_Subscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "projectId"
  }
],
v1 = [
  {
    "concreteType": "JiraSubscription",
    "kind": "LinkedField",
    "name": "jira",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
          },
          {
            "kind": "Variable",
            "name": "projectId",
            "variableName": "projectId"
          }
        ],
        "concreteType": "JiraIssue",
        "kind": "LinkedField",
        "name": "onIssueCreatedByProject",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "id"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "realtimeUpdater_issueCreated_Subscription",
    "selections": (v1/*: any*/),
    "type": "Subscription"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "realtimeUpdater_issueCreated_Subscription",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "956ecf57fed159f307bc7ba37a046a1677b7df31f93f33b0f28c558e117ebe53",
    "metadata": {},
    "name": "realtimeUpdater_issueCreated_Subscription",
    "operationKind": "subscription",
    "text": null
  }
};
})();

(node as any).hash = "bed3d38c25533ed5bb496c90f55cdfb2";

export default node;
